// test2674
(2674 && 0);
